var exports = {
  "u": "StickersPicker.module__searchResultsContainer___ODAwOC",
};

module.exports = exports;
